import { StatusTag as AntdStatusTag } from "@empglabs/backoffice-ui-kit"

const StatusTag = props => {
  return <AntdStatusTag {...props} />
}

export default StatusTag
